import styled from 'react-emotion';
import { themeGet } from 'styled-system';

// @border
// TODO: define color
export const Nav = styled('nav')`
  border-bottom: 2px solid #e8e8fb;
`;

// @flex
export const List = styled('ul')`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: nowrap;
`;

// @padding
export const ListItem = styled('li')`
  cursor: pointer;
  position: relative;
  display: inline-block;
  padding: ${themeGet('space.1')}px;
  color: ${themeGet('colors.greyDark')};

  &:hover,
  &.active {
    color: ${themeGet('colors.blueDarker')};
  }

  &::before {
    content: "";
    display: block;
    left: 0;
    bottom: -2px;
    width: 100%;
    position: absolute;
    border-bottom: 2px solid ${themeGet('colors.blueDarker')};
    transform: scaleX(0);
    opacity: 0;
    transition: all 0.25s linear;
  }

  &:hover::before,
  &.active::before {
    opacity: 1;
    transform: scaleX(1);
  }

  &:hover::before + li {
    color: ${themeGet('colors.blueDarker')};
  }
`;

// TODO: necessary?
export const ListPanel = styled('div')``;



// WEBPACK FOOTER //
// ../shop_main/components/tabNav/style.js